import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-pagenation',
  imports: [CommonModule, TranslateModule],
  templateUrl: './pagenation.component.html',
  styleUrl: './pagenation.component.scss'
})
export class PagenationComponent {
  @Input() data!: any;
  @Input() showInfo:boolean = true;
  @Output() pageChangeEvent = new EventEmitter<number>();
  displayPages: any[] = [];

  // This method is used to handle the on changes lifecycle hook using changes
  ngOnChanges(changes: SimpleChanges): void {
    if (this.data) {
      this.buildDisplayPages();
    }
  }

  // generate pagenation with ellipsis
  // This method is used to build display pages
  private buildDisplayPages(): void {
    const total = this.data.totalPages ? this.data.totalPages : this.data.totalPages;
    const current = this.data.currentPage;

    const pagesSet = new Set<number>();

    if (total <= 7) {
      for (let i = 1; i <= total; i++) pagesSet.add(i);
    } else {
      pagesSet.add(1);
      pagesSet.add(total);
      if (current > 1) pagesSet.add(current - 1);
      pagesSet.add(current);
      if (current < total) pagesSet.add(current + 1);
    }

    const sortedPages = Array.from(pagesSet).sort((a, b) => a - b);
    const final: (number | { type: 'ellipsis', target: number })[] = [];

    for (let i = 0; i < sortedPages.length; i++) {
      const cur = sortedPages[i];
      const prev = sortedPages[i - 1];

      if (prev !== undefined && cur - prev > 1) {
        // Insert clickable ellipsis targeting halfway
        const target = Math.floor((prev + cur) / 2);
        final.push({ type: 'ellipsis', target });
      }
      final.push(cur);
    }
    this.displayPages = final;
  }

  // This method is used to go to page using p
  goToPage(p: number) {
    if (p >= 1 && p <= this.data.totalPages && p !== this.data.currentPage) {
      this.pageChangeEvent.emit(p);
    }
  }
  // This method is used to return to the previous page
  prevPage() {
    let page = this.data.currentPage - 1;
    this.goToPage(page);
  }
  // This method is used to move to the next page
  nextPage() {
    let page = this.data.currentPage + 1;
    this.goToPage(page);
  }
  // This method is used to handle page click using item
  handlePageClick(item: any | { type: 'ellipsis', target: number }) {
    if (typeof item === 'number') {
      this.goToPage(item);
    } else if (item.type === 'ellipsis') {
      this.goToPage(item.target);
    }
  }
}
